module.exports = __webpack_public_path__ + "media/images/vr_ende-4ef0d06c169a651c7f72b472c599cfe5.png";